<template>
  <div class="font-GTWalsheimPro" id="main">
    <router-view />
    <broadcasting ref="broadcast" v-if="user" />
  </div>
</template>

<script setup>
import Broadcasting from './components/Broadcasting.vue';
import { onMounted, ref, computed } from 'vue';
import { useStore } from 'vuex';
import { captureRedirectUrl } from './utils/helper';

const broadcast = ref(null);
const store = useStore();

const user = computed(() => store.getters['auth/userDetails']);

onMounted(async () => {
  try {
    captureRedirectUrl(store);
    if (store.getters['auth/accessToken'] !== null) {
      //user token is present, now get user to see if email has been verified

      if (user.value?.emailIsVerified) {
        broadcast.value.connect();
        broadcast.value.bindChannels();
        // this.$refs.broadcast.disconnect()
      }
      if (store.getters['global/getCountries']?.length < 1) {
        store.dispatch('global/getCountries');
      }
    }
  } catch (error) {
    process.env.NODE_ENV === 'development' ? console.warn(error) : '';
  }
  window.addEventListener(
    'keydown',
    (event) => {
      if (event.defaultPrevented) return; // Do nothing if the event was already processed
      const aForm = document.querySelector('form');
      if (event.key === 'Enter' && aForm) {
        const btn = aForm.querySelector('button');
        if (btn) {
          btn.click();
          // Cancel the default action to avoid it being handled twice
          event.preventDefault();
        }
      }
    },
    true,
  );
});
</script>

<style></style>
